import ViewUserPage from "../../component/users/dynamic-users/ViewUser"

 
function ViewUser() {
  return (
    <div className="page-body"><ViewUserPage/></div>
  )
}

export default ViewUser